import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Callout } from '@bingads-webui-react/callout';

import { FLUCTUATION_CALLOUT_CLASSNAME } from '../constants';

const CALLOUT_HORIZONTAL_SPACE = 500;

export function CalloutWithAutoPlacement({
  target, onDismiss, children, calloutKey, className,
}) {
  const [autoFixPlacement, setAutoFixPlacement] = useState('right');

  /* istanbul ignore next */
  useEffect(() => {
    let fixedPlacement = autoFixPlacement;
    const { left, right } = target.getBoundingClientRect();
    switch (autoFixPlacement) {
      case 'right':
        fixedPlacement = right + CALLOUT_HORIZONTAL_SPACE > window.innerWidth ? 'left' : 'right'; break;
      case 'left':
        fixedPlacement = left - CALLOUT_HORIZONTAL_SPACE < 0 ? 'right' : 'left'; break;
      default:
        break;
    }
    setAutoFixPlacement(fixedPlacement);
  }, [autoFixPlacement, target]);

  return (
    <Callout
      key={calloutKey}
      popoverId={_.uniqueId('callout_')}
      popoverClassName={className}
      target={target}
      show
      closeButton
      focusLockContent
      content={children}
      onClose={e => onDismiss(e, target)}
      placement={autoFixPlacement}
    />
  );
}

CalloutWithAutoPlacement.propTypes = {
  target: PropTypes.instanceOf(Element).isRequired,
  onDismiss: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  calloutKey: PropTypes.string,
  className: PropTypes.string,
};

CalloutWithAutoPlacement.defaultProps = {
  onDismiss: _.noop,
  calloutKey: '',
  className: FLUCTUATION_CALLOUT_CLASSNAME,
};
